import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { ManageUsersComponent } from '@usermanagement/.';
import { ManageSupportDocumentMessageComponent } from '@supportdocumentmanagement/.';
import { ManageBasesComponent } from '@schoolmanagement/.';
import {
  ViewPupilListComponent,
  StudentSummaryComponent
} from '@exclusionmodule/.';
import { DirtyCheckGuard } from '@shared/guards/dirty-check.guard';
import { RegisterUserComponent } from '@oneeducation/app-core';

const routes: Routes = [
  {
    // Needed for hash routing
    path: 'error',
    component: AppComponent
  },
  {
    // Dedicated route for redirects
    path: 'auth',
    component: MsalRedirectComponent
  },
  {
    // Needed for hash routing
    path: '',
    component: AppComponent
  },
  {
    // Needed for hash routing
    path: 'state',
    canActivate: [MsalGuard],
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    // Needed for hash routing
    path: 'code',
    canActivate: [MsalGuard],
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [MsalGuard],
    redirectTo: '',
    pathMatch: 'full',
    canDeactivate: [DirtyCheckGuard]
  },
  {
    path: 'register-user',
    component: RegisterUserComponent,
    pathMatch: 'full'
  },
  {
    path: 'users/manageusers',
    component: ManageUsersComponent,
    loadChildren: () =>
      import('@usermanagement/user-management.module').then(
        (m) => m.UserManagementModule
      )
  },
  {
    path: 'schools/managebases',
    component: ManageBasesComponent,
    loadChildren: () =>
      import('@schoolmanagement/school-management.module').then(
        (m) => m.SchoolManagementModule
      )
  },
  {
    path: 'exclusions/pupildetails',
    component: ViewPupilListComponent,
    children: [
      {
        path: 'exclusions/pupildetails',
        component: ViewPupilListComponent,
        canDeactivate: [DirtyCheckGuard]
      }
    ],
    canDeactivate: [DirtyCheckGuard]
  },
  {
    path: 'exclusions/studentsummary',
    component: StudentSummaryComponent,
    loadChildren: () =>
      import('@exclusionmodule/exclusion.module').then((m) => m.ExclusionModule)
  },
  {
    path: 'supportdocument/managesupportdocumentmessage',
    component: ManageSupportDocumentMessageComponent,
    loadChildren: () =>
      import(
        '@supportdocumentmanagement/support-document-management.module'
      ).then((m) => m.SupportDocumentManagementModule)
  }
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      useHash: true,
      // Don't perform initial navigation in iframes
      initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
